module.exports = __webpack_public_path__ + "static/media/Uploading.5cc85872.svg";